export default __webpack_public_path__ + "static/media/imaging-result1-checklist.cd413a9f.svg";